import moment from 'moment'
import styles from './index.module.css'
import { columnHelper } from '../../../iba-components/Table'

const Link = (status, url, handleClickDatabricksLink) => {
    return url ? (
        <button className={`${styles.link_button}`} type="button" onClick={() => handleClickDatabricksLink(url)}>
            <span className={`${styles.link}`}>{status}</span>
        </button>
    ) : (
        <button className={`${styles.link_button}`} type="button">
            <span>{status}</span>
        </button>
    )
}

const Modal = (status, row, handleClickAnalysisDetailsModal) => {
    return (
        <button className={`${styles.link_button}`} type="button" onClick={() => handleClickAnalysisDetailsModal(row)}>
            <span className={`${styles.link}`}>{status}</span>
        </button>
    )
}

const Download = (label, id, handleClickDownload) => {
    return (
        <button className={`${styles.link_button}`} type="button" onClick={() => handleClickDownload(id)}>
            <span className={`${styles.link}`}>{label}</span>
        </button>
    )
}

export const getColumnList = (t, handleClickDatabricksLink, handleClickAnalysisDetailsModal, handleClickDownload) => [
    columnHelper.accessor('usage_or_client_folder', {
        header: t('consultingAnalysis.list.usage_or_client_folder')
    }),
    columnHelper.accessor('theme_name', {
        header: t('consultingAnalysis.list.theme_name')
    }),
    columnHelper.accessor('created_date', {
        header: t('consultingAnalysis.list.created_date'),
        cell: (props) => (props.getValue() ? moment(props.getValue()).format('YYYY-MM-DD HH:mm:ss') : '')
    }),
    // ${props.row.original.databricks_url}
    columnHelper.accessor('status', {
        header: t('consultingAnalysis.list.status.title'),
        size: 80,
        cell: (props) => {
            const status = props.getValue()
            const status_text =
                status === 0
                    ? t('consultingAnalysis.list.status.pending')
                    : status === 1
                    ? t('consultingAnalysis.list.status.analysis')
                    : status === 2
                    ? t('consultingAnalysis.list.status.success')
                    : status === 3
                    ? t('consultingAnalysis.list.status.failed')
                    : t('consultingAnalysis.list.status.undefined')
            return Link(status_text, props.row.original.databricks_url, handleClickDatabricksLink)
        }
    }),

    columnHelper.accessor('id', {
        header: t('consultingAnalysis.list.id'),
        cell: (props) => {
            return props.row.original.status === 2
                ? Download(t('consultingAnalysis.list.id'), props.getValue(), handleClickDownload)
                : ''
        }
    }),
    columnHelper.accessor('parameters_str', {
        header: t('consultingAnalysis.list.parameters_str'),
        cell: (props) => {
            return Modal(
                t('consultingAnalysis.list.parameters_str_button'),
                props.row.original,
                handleClickAnalysisDetailsModal
            )
        }
    }),
    columnHelper.accessor('user_name', {
        header: t('consultingAnalysis.list.user_name')
    })
]
